function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9001 13.9H10.2001C9.6001 13.9 9.1001 14.4 9.1001 15C9.1001 15.6 9.6001 16.1 10.2001 16.1H18.9001C19.5001 16.1 20.0001 15.6 20.0001 15C20.0001 14.4 19.5001 13.9 18.9001 13.9Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9 16.2H10.2C9.6 16.2 9 15.6 9 15C9 14.4 9.5 13.8 10.2 13.8H18.9C19.6 13.8 20.1 14.3 20.1 15C20.1 15.7 19.6 16.2 18.9 16.2ZM10.2 14.1C9.7 14.1 9.3 14.5 9.3 15C9.3 15.5 9.7 15.9 10.2 15.9H18.9C19.4 15.9 19.8 15.5 19.8 15C19.8 14.5 19.4 14.1 18.9 14.1H10.2Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9001 24.7H9.2001C8.6001 24.7 8.1001 25.2 8.1001 25.8C8.1001 26.4 8.6001 26.9 9.2001 26.9H21.9001C22.5001 26.9 23.0001 26.4 23.0001 25.8C23.0001 25.2 22.5001 24.7 21.9001 24.7Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9 27H9.2C8.6 27 8 26.5 8 25.8C8 25.1 8.5 24.6 9.2 24.6H21.9C22.6 24.6 23.1 25.1 23.1 25.8C23.1 26.5 22.6 27 21.9 27ZM9.2 24.9C8.7 24.9 8.3 25.3 8.3 25.8C8.3 26.3 8.7 26.7 9.2 26.7H21.9C22.4 26.7 22.8 26.3 22.8 25.8C22.8 25.3 22.4 24.9 21.9 24.9H9.2Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1001 29.1H9.2001C8.6001 29.1 8.1001 29.6 8.1001 30.2C8.1001 30.8 8.6001 31.3 9.2001 31.3H20.0001C20.6001 31.3 21.1001 30.8 21.1001 30.2C21.1001 29.6 20.6001 29.1 20.1001 29.1Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1 31.4H9.2C8.5 31.4 8 30.9 8 30.2C8 29.5 8.6 29 9.2 29H20C20.7 29 21.2 29.5 21.2 30.2C21.2 30.9 20.7 31.4 20.1 31.4ZM9.2 29.3C8.7 29.3 8.3 29.7 8.3 30.2C8.3 30.7 8.7 31.1 9.2 31.1H20C20.5 31.1 20.9 30.7 20.9 30.2C20.9 29.7 20.5 29.3 20 29.3H9.2Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3001 9.80002C28.9628 9.80002 29.5001 9.26277 29.5001 8.60002C29.5001 7.93728 28.9628 7.40002 28.3001 7.40002C27.6374 7.40002 27.1001 7.93728 27.1001 8.60002C27.1001 9.26277 27.6374 9.80002 28.3001 9.80002Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3001 21.2C28.9628 21.2 29.5001 20.6627 29.5001 20C29.5001 19.3372 28.9628 18.8 28.3001 18.8C27.6374 18.8 27.1001 19.3372 27.1001 20C27.1001 20.6627 27.6374 21.2 28.3001 21.2Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3001 15.5C28.9628 15.5 29.5001 14.9627 29.5001 14.3C29.5001 13.6372 28.9628 13.1 28.3001 13.1C27.6374 13.1 27.1001 13.6372 27.1001 14.3C27.1001 14.9627 27.6374 15.5 28.3001 15.5Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M27 20.4V32.4C27 33.9 25.8 35 24.4 35H5.1C3.6 35 2.5 33.8 2.5 32.4V5.1C2.5 3.6 3.7 2.5 5.1 2.5H24.6C25.9 2.5 27 3.6 27 4.9V8.6C27 8.9 27.2 9.1 27.5 9.1H29C29.3 9.1 29.5 8.9 29.5 8.6V4.9C29.5 2.2 27.3 0 24.6 0H5.1C2.3 0 0 2.3 0 5.1V32.3C0 35.1 2.3 37.4 5.1 37.4H24.3C27.1 37.4 29.4 35.1 29.4 32.3V20.3C29.4 20 29.2 19.8 28.9 19.8H27.4C27.2 19.9 27 20.1 27 20.4Z"
});

function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.57f8454f.svg";
export { ForwardRef as ReactComponent };